"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransfer = void 0;
const moment_1 = __importDefault(require("moment"));
const shift_context_1 = require("@app/component/modals/shift-1.5/shift-context");
const transfer_create_1 = require("@app/request/transfer-create");
const store_1 = __importDefault(require("@app/store"));
const util_1 = require("@app/util");
const is_loading_1 = __importDefault(require("../is-loading"));
const formHasPosition = (t) => Boolean(t.position);
const createTransfer = async ({ form, targetWsId, shiftId, beforeCreate, type, }) => {
    const dispatch = store_1.default.dispatch;
    try {
        const { workspaceId, workspaceEvents, organizationId } = store_1.default.getState();
        if (!(0, util_1.isValue)(workspaceId) || !targetWsId || !formHasPosition(form))
            return;
        if (beforeCreate) {
            await beforeCreate();
        }
        await dispatch((0, is_loading_1.default)(shift_context_1.SAVING_SHIFT_ACTION));
        await dispatch((0, is_loading_1.default)(shiftId ? 'update-live-shift' : 'create-shift'));
        const { localityId, ...data } = form;
        const transferDetail = await (0, transfer_create_1.organizationTransferCreateRequest)({
            data: shiftId ? undefined : data,
            fromWorkspace: workspaceId,
            toWorkspace: targetWsId,
            organization: organizationId ?? '??',
            shiftId,
            autoApprove: type === 'dsProTransfer',
        });
        // if the shift is put into closed day, warn the user
        if (transferDetail?.period?.start && transferDetail.period.end) {
            const closedEv = workspaceEvents.find((ev) => ev.type === 'closed' &&
                (0, moment_1.default)(transferDetail.period?.start).isBefore(ev.period?.end) &&
                (0, moment_1.default)(transferDetail.period?.end).isAfter(ev.period?.start));
            if (closedEv) {
                util_1.notification.warn({ code: 'addedShiftInClosedDay', message: '' });
            }
        }
        await dispatch((0, is_loading_1.default)(shift_context_1.SAVING_SHIFT_ACTION, true));
        await dispatch((0, is_loading_1.default)(shiftId ? 'update-live-shift' : 'create-shift', true));
        return transferDetail;
    }
    catch (error) {
        await dispatch((0, is_loading_1.default)(shift_context_1.SAVING_SHIFT_ACTION, true));
        await dispatch((0, is_loading_1.default)(shiftId ? 'update-live-shift' : 'create-shift', true));
    }
};
exports.createTransfer = createTransfer;
